import { createContext } from 'react';
export var MainContext = createContext(undefined);
